module.exports = __webpack_public_path__ + "img/keyPointReport.02538d07.png";